import { FC, useEffect } from 'react';
import { useStore } from '../../state';

type CriticalErrorProps = {
  message?: string;
};

const CriticalError: FC<CriticalErrorProps> = ({ message }) => {
  const { applicationStore } = useStore();

  useEffect(() => {
    applicationStore.criticalError(message);
  }, []);

  return null;
};

export default CriticalError;
